export const INTERVALS = {
    daily: 24 * 3600 * 1000,
    biDaily: 24 * 3600 * 1000 * 2,
    weekly: 24 * 3600 * 1000 * 7,
    monthly: 24 * 3600 * 1000 * 30,
};
